import PickingSupplyForSubcontract from '@/models/PickingSupplyForSubcontract/PickingSupplyForSubcontract';

export default class PickingSupplyForSubcontractFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.pickingSupplyForSubcontractNumber = '';
		this.workOrderSupplySubcontractId  = '';
		this.workOrderSupplySubcontractMaterialIssueNumber = '';
		this.documentStatusId  = '';
		this.documentStatusName = '';
		this.materialIssueDateFrom = '';
		this.materialIssueDateTo = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			pickingSupplyForSubcontractNumber : '0',
			workOrderSupplySubcontractId : '0',
			workOrderSupplySubcontractMaterialIssueNumber : '0',
			documentStatusId : '0',
			documentStatusName : '0',
			materialIssueDateFrom : '0',
			materialIssueDateTo : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}